import React from "react";
import {
  Card,
  CardContent,
  Typography,
  Box,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Divider,
  Chip,
  Stack,
  Grid,
} from "@mui/material";
import { EmojiEvents, ConfirmationNumber, Info, SportsMotorsports } from "@mui/icons-material";
import { Bike } from "lucide-react";
import { getPrimaryColorByAccountId } from "../../utils/styleConstants";

const JGRInfo = () => {
  return (
    <Grid item  xs={12} xl={12} lg={12} sm={12} p={4}>
         <Box
            sx={{
              p: 4,
              borderRadius: 4,
              boxShadow: 3,
              backgroundColor: '#fff',
              maxWidth: 600,
              margin: '0 auto',
            }}
          >
            <Typography
              variant="h4"
              fontWeight="bold"
              fontStyle="italic"
              gutterBottom
            >
              🥇 1er Premio
            </Typography>

            <Stack spacing={1} sx={{ mb: 3 }}>
              <Typography>🚗 Aveo 2008</Typography>
              <Typography>❄️ Full a/c</Typography>
              <Typography>⚙️ Sincrónico</Typography>
              <Typography>🛞 Cauchos nuevos</Typography>
              <Typography>🖥️ Pantalla Android</Typography>
              <Typography>🦼 Tapicería en piel</Typography>
              <Typography>💎 Cero detalles</Typography>
            </Stack>

            <Divider sx={{ my: 2 }} />

            <Typography variant="h6" fontWeight="bold" gutterBottom>
              💸 Premios semanales de $100 c/u
            </Typography>
            <Stack spacing={0.5} sx={{ mb: 3 }}>
              <Typography>📅 Abril 18</Typography>
              <Typography>📅 Abril 25</Typography>
              <Typography>📅 Mayo 02</Typography>
              <Typography>📅 Mayo 09</Typography>
              <Typography>📅 Mayo 16</Typography>
            </Stack>

            <Divider sx={{ my: 2 }} />

            <Typography fontStyle="italic" sx={{ mb: 2 }}>
              🎁 <strong>Si llevas más de 10 tickets</strong>, le metemos <strong>$500 💵💵</strong> en la guantera
            </Typography>

            <Typography variant="body1" color="text.secondary" gutterBottom>
              ⏳ <strong>Se anunciara la fecha del sorteo cuando se llegue al 80% de los tickets vendidos</strong><br />
              📍 Lotería Super Gana - 10pm
            </Typography>

              <Typography
                variant="body1"
                align="center"
                fontWeight="bold"
                mt={4}
              >
                El sorteo se realizará la fecha pautada siempre y cuando esté el 80% completado ⏳🙏🍀
              </Typography>

            <Typography variant="h6" align="center" color="success.main" fontWeight="bold" mt={4}>
              🤑 ¡BUENA SUERTE PARA TODOS! 🤑
            </Typography>
          </Box>
          <Grid item xs={12} p={4}>
            <Box
              sx={{
                borderRadius: 4,
                p: 4,
                textAlign: 'center',
                position: 'relative',
                animation: 'gold-glow 3s ease-in-out infinite',
                boxShadow: '0 0 20px 4px rgba(255, 215, 0, 0.6)',
                border: '3px solid gold',
          
                '@keyframes gold-glow': {
                  '0%': {
                    boxShadow: '0 0 10px 2px rgba(255, 215, 0, 0.3)',
                  },
                  '50%': {
                    boxShadow: '0 0 20px 6px rgba(255, 215, 0, 0.8)',
                  },
                  '100%': {
                    boxShadow: '0 0 10px 2px rgba(255, 215, 0, 0.3)',
                  },
                },
              }}
            >
              <Typography
                variant="h4"
                fontWeight="bold"
                fontFamily="Phrastic"
                gutterBottom
              >
                NÚMEROS PREMIADOS
              </Typography>
              <Grid container spacing={2} justifyContent="center" mt={2}>
                {['0000', 
                  2222,
                  4444,
                  6666,
                  8888].map((num, index) => (
                  <Grid item key={index}>
                    <Chip
                      label={num}
                      sx={{
                        fontSize: '1.2rem',
                        fontWeight: 'bold',
                        color: 'white',
                        px: 2,
                        py: 1,
                        borderRadius: '8px',
                        boxShadow: 2,
                        animation: 'winner-bounce 1.5s infinite ease-in-out',
                        transition: 'transform 0.2s ease-in-out',
          
                        '&:hover': {
                          backgroundColor: 'white',
                          cursor: 'pointer',
                          transform: 'scale(1.1)',
                        },
          
                        '@keyframes winner-bounce': {
                          '0%, 100%': {
                            transform: 'translateY(0)',
                          },
                          '50%': {
                            transform: 'translateY(-5px)',
                          },
                        },
                      }}
                    />
                  </Grid>
                ))}
              </Grid>
            </Box>
          </Grid>
          </Grid>
  );
};

export default JGRInfo;
